import Dialog from "@mui/material/Dialog";
import {DiscordRoleData} from "../../data/discord/DiscordRoleData";
import {Button, DialogActions, DialogTitle, Input, Stack} from "@mui/material";
import React, {useEffect, useState} from "react";
import DialogContent from "@mui/material/DialogContent";
import {DivisionRoles} from "../../data/DivisionRoles";
import {DiscordRole} from "./DiscordRole";
import {LoadingContent} from "../LoadingContent";
import {clamp} from "../../utils";
import {makeApiCall} from "../../hooks/CancellableApiCall";

interface DiscordRoleLinkDialogProps {
    open: boolean,
    roles: DiscordRoleData[]
    divisionRole: DivisionRoles
}

interface DiscordRoleLinkDialogRoleContentProps extends DiscordRoleLinkDialogProps {
    associations: string[]
}

const DiscordRoleLinkDialogRoleContent = (props: DiscordRoleLinkDialogRoleContentProps) => {
    const [filter, setFilter] = useState("")
    const [associations, setAssociations] = useState(props.associations)

    function modifyRoleAssociation(add: boolean, did: number, rid: string) {
        makeApiCall({
            url: `/api/discord/role/${did}/${add ? "associate" : "dissociate"}/${rid}`,
            method: add ? "PUT" : "DELETE",
            onLoadedCallback: () => {},
            onError: () => {}
        })
    }

    return <>
        <DialogContent>
            <Input sx={{width: "400px"}}
                   placeholder={"Enter discord role name here"}
                   onChange={(event) => setFilter(event.target.value)}/>
        </DialogContent>
        <DialogContent>
            <Stack spacing={1}>
                {props.roles && props.roles.filter((T) => {
                    return T.displayName.toLowerCase().includes(filter.toLowerCase())
                }).sort((a, b) => {return Number((associations.includes(b.roleId))) - Number((associations.includes(a.roleId)))})
                    .slice(0, clamp(associations.length, 5, 15)).map((role) => {
                    return <DiscordRole
                        key={role.roleId}
                        role={role}
                        checked={associations.includes(role.roleId)}
                        doClick={(role) => {
                            if (!associations.includes(role.roleId)) {
                                modifyRoleAssociation(true, props.divisionRole.roleId, role.roleId)
                                setAssociations([...associations, role.roleId])
                            } else {
                                modifyRoleAssociation(false, props.divisionRole.roleId, role.roleId)
                                setAssociations(associations.filter(T => {return T !== role.roleId}))
                            }
                        }}
                    />
                })}
            </Stack>
        </DialogContent>
    </>
}

// TODO: The need to force refresh
export const DiscordRoleLinkDialog = (props: DiscordRoleLinkDialogProps) => {
    const [open, setOpen] = useState(props.open)
    const [currentAssociations, setCurrentAssociations] = useState<string[] | undefined>(undefined)

    useEffect(() => {
        const fetchData = async () => {
            if (open && currentAssociations === undefined) {
                try {
                    const response = await fetch(`/api/discord/${props.divisionRole.roleId}/associations`)
                    const data = await response.json()
                    setCurrentAssociations(data)
                } catch (error) {
                    console.error('Error fetching associations:', error)
                }
            }
        }
        fetchData()
    }, [open, currentAssociations, props.divisionRole.roleId])

    return <>
        <Button color={"info"} onClick={() => {
            setOpen(true)
        }} variant={"contained"}>Modify Discord Role Association</Button>
        <Dialog
            open={open}
            fullWidth={true}
            onClose={() => {setOpen(false)}}
        >
            <DialogTitle>
                {props.divisionRole.displayName}
            </DialogTitle>
            <DialogContent>
                <LoadingContent isLoading={currentAssociations === undefined} showLoadingSkeleton={true}>
                    <DiscordRoleLinkDialogRoleContent
                        associations={currentAssociations!!}
                        open={false}
                        roles={props.roles}
                        divisionRole={props.divisionRole}
                    />
                </LoadingContent>
            </DialogContent>
            <DialogActions>
                <Button color={"info"} onClick={() => {
                    setOpen(false)
                }} variant={"contained"}>Close</Button>
            </DialogActions>
        </Dialog>
    </>
}